import {
  FETCH_FARE_RULES,
  FETCH_FARE_RULES_SUCCESS,
  FETCH_FARE_RULES_FAILED,
  EDIT_FARE_RULES
} from "../store/types";

export const INITIAL_STATE = {
  rules: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const farerulesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_FARE_RULES:
      return {
        ...state,
        loading: true
      };
    case FETCH_FARE_RULES_SUCCESS:
      return {
        ...state,
        rules: action.payload,
        loading: false,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_FARE_RULES_FAILED:
      return {
        ...state,
        rules: [],
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_FARE_RULES:
      return state;
    default:
      return state;
  }
};
